import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { baseURL } from "../BaseUrl";
// import { salesbeeImgAuth } from "./HeaderAuthentication";

function AddBulkClient(props) {
  const [bulkClientFile, setBulkClientFile] = useState("");
  const [bulkUploadResponse, setBulkUploadResponse] = useState({
    res: null,
    message: null,
  });
  const [uploadExcelFile, setUploadExcelFile] = useState("");

  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const salesbeeImgAuth = { Travelize_Authentication: userDetails };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    setUploadExcelFile(fileUploaded);
  };

  useEffect(() => {
    setUploadExcelFile("");
    setBulkUploadResponse({ res: "", message: "" });
  }, [props.show, props.handleCloseBulkClient]);

  const addBulkClient = () => {
    if (uploadExcelFile !== null || uploadExcelFile !== "") {
      const formData = new FormData();
      formData.append("Files", uploadExcelFile);
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: salesbeeImgAuth,
        body: formData,
      };
      fetch(
        `${baseURL}/api/Import/ImportCustomer?Directory=BulkClientUploads`,
        requestOption
      )
        .then((res) => res.json())
        .then((res) => {

          if (res.success == true) {
            setBulkUploadResponse({ res: res.success, message: res.message });
          } else {
            setBulkUploadResponse({
              res: res.success,
              message: res.errorMessage,
            });
          }
        });
    }
  };



  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.handleCloseBulkClient}
        className="main_model"
      >
        <div className="add-meet-purpose-heading">
          <h6 className="add-edit-meetpurpose-head">ADD BULK COMPANY</h6>
          <i className="fa fa-times" onClick={props.handleCloseBulkClient} />
        </div>
        <div className="container add-edit-meetpurpose">
          <div className="company-name">
            <div className="row mb-2">
              <input
                className="form-control form add-meetpurpose-input"
                id="bulkclientupload"
                type="file"
                name="bulkUserUpload"
                accept=".xls, .xlsx"
                onChange={handleChange}
                placeholder="Add File"
              />
            </div>
          </div>
          <span className="bulk-temp-and-res-message">
            <span
              className={
                bulkUploadResponse.res
                  ? "upload-res-message success"
                  : "upload-res-message false"
              }
            >
              {bulkUploadResponse.message}
            </span>
            <a
              // onClick={uploadClick}
              href={`${baseURL}/TravelizeProData/Data/BulkUploadTemplate/Excel_BulkClient_20230216150430805.xlsx`}
              className="btn template-download"
              download={"BulkUploadTemplate"}
            // Use Download File function of excel export call
            >
              <i className="fa fa-download" /> &nbsp;Template Download
            </a>
          </span>
        </div>
        <div className="btns-save-cancel">
          <div className="meetpurpose-save-button">
            <button
              onClick={addBulkClient}
              type="button"
              className="btn btn-save-up"
              data-bs-dismiss="modal"
            >
              <i className="fa fa-upload" /> &nbsp; Bulk Upload
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AddBulkClient;
